import NumberPrecision from 'number-precision';
import DataType from '../../../../tableEngine/Script/Game/Data/Config/DataStructure';
import Result from '../../../../tableEngine/Script/Game/Data/DataObject/Result';

export enum SpinResultType {
    NONE = 0,
    BIG_WIN = 1,
    JACKPOT = 2,
    FEATURE_GAME = 3,
}

const BIG_WIN_MULTIPLIER = 5;

export class SpinResult {
    public readonly bet: number;
    public readonly win: number;
    public readonly multiplier: number;

    public readonly type: SpinResultType;
    public readonly isBigWin: boolean;
    public readonly triggerJP: boolean;
    public readonly triggerFG: boolean;

    constructor(
        data: DataType.Result.ResultData,
        public readonly index: number,
    ) {
        this.bet = data.Bet ?? 0;
        this.win = data.Win ?? 0;
        this.multiplier = NumberPrecision.divide(data.Mul ?? 0, 100);

        this.isBigWin = this.multiplier >= BIG_WIN_MULTIPLIER;
        this.triggerJP = data.GameJP ?? false;
        this.triggerFG = data.Free ?? data.Feature ?? false;
        if (this.triggerJP) {
            this.type = SpinResultType.JACKPOT;
        } else if (this.triggerFG) {
            this.type = SpinResultType.FEATURE_GAME;
        } else if (this.multiplier >= 5) {
            this.type = SpinResultType.BIG_WIN;
        } else {
            this.type = SpinResultType.NONE;
        }
    }
}

export default class SlotResult extends Result {
    public readonly spinResult: SpinResult = null;
    public readonly jackpotWin: number = 0;

    constructor(data: DataType.Table.PlayerSettleData, spinResultIndex: number) {
        super(data);
        if (data.Status !== DataType.Enums.ResultStatus.Cancelled) {
            this.spinResult = new SpinResult(
                {
                    Bet: data.TotalGameBet,
                    Win: data.TotalGameWin,
                    Mul: data.TotalGameWin ? NumberPrecision.times(NumberPrecision.divide(data.TotalGameWin, data.TotalGameBet), 100) : 0,
                    GameJP: data.GameJP ?? false,
                    Free: data.Free ?? false,
                    Feature: data.Feature ?? false,
                },
                spinResultIndex,
            );
        }
    }
}
